import React, { useContext, useState } from "react";
import { FaHeart } from "react-icons/fa";
import { Link } from "react-router-dom";
import { CartContextProvider } from "../context/CartContext";

const ProductBox = ({ image, id, name, price, alt, item }) => {
	const [like, setLike] = useState(false);
	const { addToSave, favCheckError } = useContext(CartContextProvider);

	const handleLikeAndSave = (item) => {
		const newLikeState = !like;
		addToSave(item, newLikeState);
		if (!favCheckError) {
			setLike(newLikeState);
		}
	};

	return (
		<div className="group w-full flex flex-col h-full bg-white rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
			{/* Image Section */}
			<div className="relative bg-[#fafafa] aspect-[4/5] w-full overflow-hidden">
				<Link to={`/details/${id}`} className="block w-full h-full">
					<img
						src={image}
						alt={alt}
						className="w-full h-full object-cover object-center transition-transform duration-700 ease-in-out group-hover:scale-110"
					/>
				</Link>
				
				{/* Favorite Button with Glassmorphism */}
				<button
					type="button"
					className="absolute top-3 right-3 p-2.5 rounded-full bg-white/60 backdrop-blur-md shadow-sm border border-white/20 transition-all duration-200 hover:bg-white hover:scale-110 z-10"
					onClick={() => handleLikeAndSave(item)}
					aria-label="Add to favorites"
				>
					<FaHeart className={`w-4 h-4 transition-colors ${like ? "text-[#FFB7CF]" : "text-gray-400"}`} />
				</button>
			</div>

			{/* Info Section */}
			<div className="flex flex-col flex-grow p-4 pt-5 pb-6">
				<div className="flex justify-between items-start gap-3 mb-1">
					<Link to={`/details/${id}`}>
						<h4 className="text-base md:text-lg font-semibold text-gray-900 leading-tight line-clamp-2 hover:text-[#FFB7CF] transition-colors">
							{name}
						</h4>
					</Link>
					<h4 className="text-base md:text-lg font-medium text-gray-900 shrink-0">
						${parseFloat(price).toFixed(2)}
					</h4>
				</div>
				
				<p className="text-sm text-gray-500 mb-4 mt-1">Premium Handmade Nails</p>

				<div className="mt-auto pt-2">
					<Link to={`/details/${id}`} className="block w-full">
						<button
							type="button"
							className="w-full py-2.5 px-4 bg-gray-900 hover:bg-black text-white text-sm font-medium rounded-xl transition-colors duration-200"
						>
							View Details
						</button>
					</Link>
				</div>
			</div>
		</div>
	);
};

export default ProductBox;
